import api from './api';
import * as actionTypes from './actionTypes';
import * as eventTypes from './eventTypes';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';

export function loadDocumentTasks(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    const currentDocumentTaskData = getState().tasksData[key];

    if (currentDocumentTaskData) {
      const { tasksIsChanged } = getState().tasksData;
      const { documentTasksIsLoaded } = currentDocumentTaskData;
      if (documentTasksIsLoaded && !tasksIsChanged) return;
    }

    dispatch({ type: actionTypes.LOAD_DOCUMENT_TASKS_STARTED, payload: { documentId, siteId }, id: key });
    try {
      let documentTasks = await dispatch(sendHttpRequest(api.loadDocumentTasks(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_DOCUMENT_TASKS_SUCCEEDED, payload: documentTasks, id: key });
      dispatch({ type: actionTypes.RESET_TASKS });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_DOCUMENT_TASKS_FAILED, payload: { documentId, siteId, error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadDashboardTasks(filters) {
  return async dispatch => {
    dispatch({ type: actionTypes.LOAD_DASHBOARD_TASKS_STARTED, payload: { filters } });
    try {
      let tasks = await dispatch(sendHttpRequest(api.postTasks(filters)));
      dispatch({ type: actionTypes.LOAD_DASHBOARD_TASKS_SUCCEEDED, payload: { tasks } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_DASHBOARD_TASKS_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadTaskOptions() {
  return async (dispatch, getState) => {
    let { taskOptions } = getState().tasksData;
    if (taskOptions.length > 0) {
      return;
    }

    try {
      let taskOptions = await dispatch(sendHttpRequest(api.getTaskOptions()));
      dispatch({ type: actionTypes.LOAD_TASK_OPTIONS_SUCCEEDED, payload: { taskOptions } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_TASK_OPTIONS_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadClientCategories() {
  return async (dispatch, getState) => {
    let { clientCategories } = getState().tasksData;
    if (clientCategories.length > 0) {
      return;
    }

    try {
      let clientCategories = await dispatch(sendHttpRequest(api.getClientCategories()));
      dispatch({ type: actionTypes.LOAD_CLIENT_CATEGORIES_SUCCEEDED, payload: { clientCategories } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_CLIENT_CATEGORIES_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadTaskTypes() {
  return async (dispatch, getState) => {
    let { taskTypes } = getState().tasksData;
    if (taskTypes.length > 0) {
      return;
    }

    try {
      let taskTypes = await dispatch(sendHttpRequest(api.getTaskTypes()));
      dispatch({ type: actionTypes.LOAD_TASK_TYPES_SUCCEEDED, payload: { taskTypes } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_TASK_TYPES_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadTaskResponsibles() {
  return async (dispatch, getState) => {
    let { tasksResponsibles } = getState().tasksData;
    if (tasksResponsibles.length > 0) {
      return;
    }

    try {
      let tasksResponsibles = await dispatch(sendHttpRequest(api.getTaskResponsibles()));
      dispatch({ type: actionTypes.LOAD_TASK_RESPONSIBLES_SUCCEEDED, payload: { tasksResponsibles } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_TASK_RESPONSIBLES_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadTaskStates() {
  return async (dispatch, getState) => {
    let { taskStates } = getState().tasksData;
    if (taskStates.length > 0) {
      return;
    }

    try {
      let taskStates = await dispatch(sendHttpRequest(api.getTaskStates()));
      dispatch({ type: actionTypes.LOAD_TASK_STATES_SUCCEEDED, payload: { taskStates } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_TASK_STATES_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadTaskStatuses() {
  return async (dispatch, getState) => {
    let { taskStatuses } = getState().tasksData;
    if (taskStatuses.length > 0) {
      return;
    }

    try {
      let taskStatuses = await dispatch(sendHttpRequest(api.getTaskStatuses()));
      dispatch({ type: actionTypes.LOAD_TASK_STATUSES_SUCCEEDED, payload: { taskStatuses } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_TASK_STATUSES_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadTasksCommentsConfig() {
  return async (dispatch, getState) => {
    let { tasksConfigIsLoaded } = getState().tasksData;
    if (tasksConfigIsLoaded) return;

    try {
      let tasksConfig = await dispatch(sendHttpRequest(api.getTasksCommentsConfig()));
      dispatch({ type: actionTypes.LOAD_TASKS_CONFIG_SUCCEEDED, payload: { tasksConfig } });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_TASKS_CONFIG_FAILED, payload: { error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadResponsiblesForSingleTask(taskId, search) {
  return async dispatch => {
    try {
      let taskResponsiblesForSingleTask = await dispatch(sendHttpRequest(api.loadResponsiblesForSingleTask(taskId, search)));
      dispatch({
        type: actionTypes.LOAD_TASKS_RESPONSIBLES_SUCCEEDED,
        payload: { taskId, taskResponsiblesForSingleTask }
      });
    } catch (error) {
      dispatch({ type: actionTypes.LOAD_TASKS_RESPONSIBLES_FAILED, payload: { taskId, error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function updateTask(task, responsibleId) {
  return async dispatch => {
    dispatch({ type: actionTypes.UPDATE_TASK_STARTED, payload: { task, responsibleId } });
    dispatch(sendHttpCommandAndWaitForEvent(api.updateTask(task, responsibleId), 'RunningTaskCommand', [eventTypes.DOCUMENT_TASKS_CHANGED]))
      .then(event => {
        if (event.ok) {
          dispatch({ type: actionTypes.UPDATE_TASK_SUCCEEDED, payload: { task, responsibleId } });
          dispatch({ type: actionTypes.RESET_TASKS });
        } else {
          dispatch({ type: actionTypes.UPDATE_TASK_FAILED, payload: { task, responsibleId, error: event } });
        }
      })
      .catch(error => {
        dispatch({ type: actionTypes.UPDATE_TASK_FAILED, payload: { task, responsibleId, error } });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function startTask(task) {
  return async dispatch => {
    dispatch({ type: actionTypes.START_TASK_STARTED, payload: { task } });
    dispatch(sendHttpCommandAndWaitForEvent(api.startTask(task), 'RunningTaskStartCommand', [eventTypes.DOCUMENT_TASKS_CHANGED]))
      .then(event => {
        if (event.ok) {
          dispatch({ type: actionTypes.START_TASK_SUCCEEDED, payload: { task } });
          dispatch({ type: actionTypes.RESET_TASKS });
        } else {
          dispatch({ type: actionTypes.START_TASK_FAILED, payload: { task, error: event } });
        }
      })
      .catch(error => {
        dispatch({ type: actionTypes.START_TASK_FAILED, payload: { task, error } });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function pauseTask(task, comment, selectedReasons) {
  return async dispatch => {
    dispatch({ type: actionTypes.PAUSE_TASK_STARTED, payload: { task, comment, selectedReasons } });
    dispatch(
      sendHttpCommandAndWaitForEvent(api.pauseTask(task, comment, selectedReasons), 'RunningTaskPauseCommand', [
        eventTypes.DOCUMENT_TASKS_CHANGED
      ])
    )
      .then(event => {
        if (event.ok) {
          dispatch({ type: actionTypes.PAUSE_TASK_SUCCEEDED, payload: { task, comment, selectedReasons } });
          dispatch({ type: actionTypes.RESET_TASKS });
        } else {
          dispatch({ type: actionTypes.PAUSE_TASK_FAILED, payload: { task, comment, selectedReasons, error: event } });
        }
      })
      .catch(error => {
        dispatch({ type: actionTypes.PAUSE_TASK_FAILED, payload: { task, comment, selectedReasons, error } });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}

export function updateTaskPriority(taskId, processId, isHighPriority) {
  return async dispatch => {
    dispatch({ type: actionTypes.UPDATE_TASK_PRIORITY_STARTED, payload: { taskId, processId, isHighPriority } });
    dispatch(
      sendHttpCommandAndWaitForEvent(api.updateTaskPriority({ taskId, processId, isHighPriority }), 'UpdateTaskPriorityCommand', [
        eventTypes.DOCUMENT_TASKS_CHANGED
      ])
    )
      .then(event => {
        if (event.ok) {
          dispatch({ type: actionTypes.UPDATE_TASK_PRIORITY_SUCCEEDED, payload: { taskId, processId, isHighPriority } });
          dispatch({ type: actionTypes.RESET_TASKS });
        } else {
          dispatch({ type: actionTypes.UPDATE_TASK_PRIORITY_FAILED, payload: { taskId, processId, isHighPriority, error: event } });
        }
      })
      .catch(error => {
        dispatch({ type: actionTypes.UPDATE_TASK_PRIORITY_FAILED, payload: { taskId, processId, isHighPriority, error } });
        dispatch(showError(error.message, error.correlationId));
      });
  };
}
